import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { VehiculoPasoPunto } from './../../../../../../_entities/paso-punto/vehiculo-paso-punto';
import { PuntoInteres } from './../../../../../../_entities/puntos-interes/puntoInteres';
import { PasoPuntoService } from './../../../../../monitoreo/services/paso-punto.service';
import { finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MapaMarkerComponent } from '../../../mapa-marker/mapa-marker.component';
import { IGNICIONES, ALERTAS } from './../../../../../../_entities/estados';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-paso-punto',
	templateUrl: './paso-punto.component.html',
	styleUrls: ['./paso-punto.component.scss']
})
export class PasoPuntoComponent implements OnInit {
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent

	public fechaInicio;
	public fechaFin;
	public puntosInteres: PuntoInteres[];
	public puntoInteres: Number;
	public reportePasoPunto: VehiculoPasoPunto[] = [];
	public showFilterRow: boolean;
	public loadingVisible: boolean = false;

	constructor(private dialogRef: MatDialogRef<PasoPuntoComponent>,
		private pasoPuntoService: PasoPuntoService,
		private toastService: ToastrService,
		private datepipe: DatePipe,
		private dialog: MatDialog) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.obtenerPuntosInteres();
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	obtenerPasoPunto(idPunto, fechaInicio, fechaFin) {
		if(this.validationGroup.instance.validate().isValid){
			this.loadingVisible = true;
			const fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
			const fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");

			this.pasoPuntoService.obtenerPasoPunto(idPunto, fechaInicial, fechaFinal).pipe(
				finalize(
					() => this.loadingVisible = false
				)
			).subscribe(
				(vehiculos: VehiculoPasoPunto[]) => {
					vehiculos.map(vehiculo => {

						const ignicion = IGNICIONES.find(ignicion => ignicion.id == vehiculo.ignicion);
						vehiculo.ignicion = ignicion.nombre;

						const estado = ALERTAS.find(alerta => alerta.id == vehiculo.estado);
						vehiculo.estado = estado.nombre;

						vehiculo.fechaHora = this.datepipe.transform(vehiculo.fechaHora, 'dd/MM/yyyy HH:mm');
					})
					this.reportePasoPunto = vehiculos;
				}
			)
		} else {
			this.toastService.warning('Existen uno o mas campos vacios');
		}

	}

	obtenerPuntosInteres() {
		this.pasoPuntoService.obtenerPuntosInteres().subscribe(
			(puntosInteres: PuntoInteres[]) => {
				this.puntosInteres = puntosInteres;
			}
		)
	}

	ubicarPunto(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "50%";
		dialogConfig.height = "60%"
		dialogConfig.data = data;
		dialogConfig.panelClass = 'custom-modalbox';
		this.dialogRef.close();
		this.dialog.open(MapaMarkerComponent, dialogConfig);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
